/**
 * This is based on the original dynamicform.js
 * It's bundled with the rest of the JS.
 */
jQuery(function ($) {
	$('.customform').each(function () {
		const form = $(this)
		const formData = form.attr('formdata')

		var $markup = $('<div/>');
		$markup.formRender({ formData });

		form.find('.render-wrap').html($markup);
		form.find('.render-wrap').append('<input type="hidden" value="' + form.attr('formid') + '" name="form_id" />');

		form.submit(function (event) {
			event.preventDefault()
			validate_dynamic_form(form, formData)
		});
	});
});

function validate_dynamic_form(form, formData) {
	var form_id = form.attr('formid');
	const messages = document.getElementById('messages_' + form_id);
	var emailRgx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	var phoneRgx = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
	var GoOn = true;

	const formJson = JSON.parse(formData);

	for (var key in formJson) {

		var elementID = formJson[key].name;
		var type = formJson[key].type;
		var subtype = formJson[key].subtype;

		// Get and Set answers
		if (type != 'radio-group' && type != 'checkbox-group') {
			formJson[key].answer = objectifyForm(form.serializeArray())[elementID];
		}
		else if (type == 'checkbox-group') {
			var checkboxes = document.getElementsByName(elementID + '[]');
			var vals = [];
			for (var i = 0, n = checkboxes.length; i < n; i++) {
				if (checkboxes[i].checked) {
					vals.push(checkboxes[i].value);
				}
			}
			formJson[key].answer = vals;
		}
		else if (type == 'radio-group') {
			var radios = document.getElementsByName(elementID);
			for (var i = 0, length = radios.length; i < length; i++) {
				if (radios[i].checked) {
					formJson[key].answer = radios[i].value;
					break;
				}
			}
		}

		// Check answers
		if (formJson[key].required == true && formJson[key].answer.length == 0) { GoOn = false; }
		if (subtype == 'email' && formJson[key].answer.length > 0) {
			if (!emailRgx.test(formJson[key].answer)) {
				GoOn = false;
			}
		}
	}

	if (form_id.length == 0 || form_id == null) {
		GoOn = false;
	}

	if (GoOn) {
		submitForm(form, formJson)
	}
	else {
		!messages.classList.contains('visible') && messages.classList.add('visible')
		messages.innerHTML = siteTanslations.formRequired;
	}
}

function submitForm(form, formJson) {
	var captchaKey = form.attr('data-recaptcha-key')
	const formId = form.attr('formid')
	const messages = document.getElementById('messages_' + formId)

	grecaptcha.ready(function () {
		const submitButton = form.find('.morebutton')
		submitButton?.attr('disabled', 'disabled')

		grecaptcha.execute(captchaKey, { action: 'submit' })
			.then(function (token) {
				var frmContact = document.getElementById(form.attr('id'))
				var thisData = new FormData(frmContact)
				thisData.append('g-recaptcha-response', token)

				var xhr = new XMLHttpRequest(frmContact)
				xhr.open('POST', frmContact.action, true)

				xhr.onload = function (e) {
					var msgSend = false;
					var res = false;
					if (xhr.status === 200) {
						try {
							res = JSON.parse(xhr.response);
							if (res && res.status == 'ok') {
								msgSend = true;
							}
						}
						catch (e) { }

						window.gtag?.('event', 'Form submission', {
							event_category: 'form',
							event_label: form.attr('id'),
						})

						let sendToCode = ''
						if (form.attr('id') == 'frm_6') { // ZZP'er
							sendToCode = 'AW-10979531660/hh3-CMWq-d0DEIy3ufMo'
						}
						else if (form.attr('id') == 'frm_16') { // Instelling
							sendToCode = 'AW-10979531660/OWNfCPzp4t8DEIy3ufMo'
						}
						else if (form.attr('id') == 'frm_1') { // Contact
							sendToCode = 'AW-10979531660/EafdCP_p4t8DEIy3ufMo'
						}

						if (sendToCode) {
							window.gtag?.('event', 'conversion', { 
								send_to: sendToCode, 
								event_callback: function () {}
							})
						}
					}

					!messages.classList.contains('visible') && messages.classList.add('visible')
					messages.classList.remove('success')

					if (msgSend) {
						form.find("input:not([type=hidden]), textarea").val("");
						messages.classList.add('success')
						messages.innerHTML = siteTanslations.formThankyou;

						for (var key in formJson) {

							var elementID = formJson[key].name;
							var type = formJson[key].type;

							if (type == 'checkbox-group') {
								var checkboxes = document.getElementsByName(elementID + '[]');
								for (var i = 0, n = checkboxes.length; i < n; i++) {
									checkboxes[i].checked = false
								}
							}
							else if (type == 'radio-group') {
								var radios = document.getElementsByName(elementID);
								for (var i = 0, length = radios.length; i < length; i++) {
									radios[i].checked = false
								}
							}
						}

					}
					else {
						if (res && res.error) {
							messages.innerHTML = res.error;
						}
						else {
							messages.innerHTML = siteTanslations.formError;
						}
					}

					submitButton.attr('disabled', null)
				};
				xhr.send(thisData);
			})
	})
}

function objectifyForm(formArray) {//serialize data function

	var returnArray = {};
	for (var i = 0; i < formArray.length; i++) {
		returnArray[formArray[i]['name']] = formArray[i]['value'];
	}
	return returnArray;
}

